import React, { useState, useEffect } from 'react';
import companyService from '../../services/companyService';
import './CompanyStats.css';

function CompanyStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await companyService.getStats();

      // API returns: {totalUsers: 10, companyName: "...", subscriptionTier: "ENTERPRISE"}
      setStats(data);
    } catch (err) {
      console.error('Failed to load stats:', err);
      setError(err.message || 'Failed to load stats');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="company-stats">
        <h2>Company Statistics</h2>
        <div className="loading">Loading stats...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="company-stats">
        <h2>Company Statistics</h2>
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  if (!stats) {
    return (
      <div className="company-stats">
        <h2>Company Statistics</h2>
        <div className="error">No stats available</div>
      </div>
    );
  }

  return (
    <div className="company-stats">
      <h2>Company Statistics</h2>
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total Users</h3>
          <p className="stat-number">{stats.totalUsers || 0}</p>
          <small>{stats.companyName}</small>
        </div>

        <div className="stat-card">
          <h3>Subscription</h3>
          <p className="stat-number">{stats.subscriptionTier}</p>
          <small>Current Plan</small>
        </div>

        {stats.totalJobs !== undefined && (
          <div className="stat-card">
            <h3>Total Jobs</h3>
            <p className="stat-number">{stats.totalJobs}</p>
            <small>Job Postings</small>
          </div>
        )}

        {stats.totalCandidates !== undefined && (
          <div className="stat-card">
            <h3>Total Candidates</h3>
            <p className="stat-number">{stats.totalCandidates}</p>
            <small>Applications</small>
          </div>
        )}
      </div>
    </div>
  );
}

export default CompanyStats;